"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssueAttachmentsApi = void 0;
var _queryClientUtils = require("../util/queryClientUtils");
var _endpointHelpers = require("../util/endpointHelpers");
const IssueAttachmentsApi = exports.IssueAttachmentsApi = (0, _endpointHelpers.createEndpointSdk)(_ref => {
  let {
    api
  } = _ref;
  return {
    get: issueId => api.get("attachments/".concat(issueId, "/items")).then(result => result.attachments),
    create: attachmentData => api.create("attachments", attachmentData).then(result => result.attachments),
    delete: (issueId, attachmentId) => api.delete("attachments/".concat(issueId, "/items/").concat(attachmentId))
  };
}, {
  invalidateByQueryKeys: () => _queryClientUtils.NO_QUERIES_TO_INVALIDATE
});
//# sourceMappingURL=IssueAttachmentsApi.js.map